export default {
	connectTitle: 'Connectez-vous pour accéder à la liste des trackers',
	mailPlaceholder: 'Adresse email',
	passwordPlaceholder: 'Mot de passe',
	connectError: 'Erreur lors de la connexion',
	connectButton: 'Se connecter',
	selectTrackers: 'Selectionnez un tracker',
	discoverButton: 'Découvrir',
	zoomIn: 'Zoomer',
	zoomOut: 'Dézoomer',
	pdfDownload: 'Télécharger le PDF',
	docDownload: `Télécharger l'analyse`,
	watchVideo: 'Méthodologie en vidéo',
	howToRead: 'Comment lire ?',
	otherTrackers: 'Autres trackers',
	signOut: 'Déconnexion',
	discoverVerbatim: 'Découvrez les verbatim',
	goodPractice: 'Bonne pratique',
	priority: 'Priorité',
	weakness: 'Signal faible',
	strength: 'Point fort',
	contactUs: 'Contactez-nous',
	back: 'Retour',
	titles: {
		login: 'KPAM - Trackers',
		trackers: 'KPAM - Trackers',
		tracker: 'KPAM - Trackers',
		zoom: 'KPAM - Trackers',
		verbatim: 'KPAM - Trackers'
	},
	positiveImpact: {
		title: 'Impact positif',
		text: `C'est l'intensité du discours des clients promoteurs (l'effet 'waouh').`
	},
	averageSatisfaction: {
		title: 'Satisfaction moyenne',
		text: `C'est la tonalité moyenne du discours de l'ensenmble des clients.`
	},
	negativeImpact: {
		title: 'Impact négatif',
		text: "C'est l'intensité du discours des clients détracteurs (l'intensité de la frustration)."
	},
	occurrence: {
		title: "Occurrence",
		text: "C'est le pourcentage de clients qui se sont exprimés sur le sujet."
	},
	prioritySite: {
		title: "Chantier prioritaire",
		text: "Forte concurrence et fort potentiel de progression de la satisfaction moyenne."
	},
	weaknessCaption: {
		title: "Signal faible",
		text: "Une faible occurrence mais un fort impact négatif"
	},
	strengthCaption: {
		title: "Point fort",
		text: "Forte occurrence et tonalité <br/>moyenne élevée."
	},
	goodPracticeCaption: {
		title: "Bonne pratique",
		text: "Une faible occurrence mais un fort impact positif."
	},
	bddf: {
		title: "BDDF (détail des initiales à indiquer)"
	},
	bpf: {
		title: "BPF (détail des initiales à indiquer)"
	},
	risingOccurrence: {
		title: "Occurrence en hausse"
	},
	stableOccurrence: {
		title: "Occurrence stable"
	},
	fallingOccurrence: {
		title: "Occurrence en baisse"
	},
	badNavigator: `Impossible d'accéder aux trackers !
	Pour les visualiser et accéder à toutes les fonctionnalités, merci de mettre à jour votre navigateur.`
};